module.exports = __webpack_public_path__ + "assets/img/videoBg.d9e39536.png";